import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPassword, forceChangePassword } from '../services/authService';

const ResetPassword = () => {
    const [confirmPassword, setConfirmPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [msg, setMsg] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword != confirmPassword) {
            setError("Password do not match");
            return;
        }

        setLoading(true);
        setError('');
        setMsg('');


        try {
            if (token) {
                // Flow 1: Standard reset via "Forgot Password" email link
                await resetPassword({ token, newPassword });
            } else {
                // Flow 2: Forced reset on first login
                const tempAuthStr = localStorage.getItem("tempAuth");
                if (!tempAuthStr) {
                    throw new Error("Invalid password reset request. Missing token or session.");
                }
                const tempAuth = JSON.parse(tempAuthStr);
                await forceChangePassword({ userId: tempAuth.userId, newPassword });
                localStorage.removeItem("tempAuth"); // Clean up after success
            }

            setMsg('Password reset successful! Redirecting...');
            setTimeout(() => navigate('/smartcity/login'), 2000);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to reset password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg border mt-10">
            <h2 className="text-2xl font-semibold text-center mb-4">Reset Password</h2>
            {msg && <div className="text-green-500 mb-2">{msg}</div>}
            {error && <div className="text-red-500 mb-2">{error}</div>}

            <form onSubmit={handleSubmit}>
                {/* New Password */}
                <div className="mb-4">
                    <input
                        type={showNewPassword ? 'text' : 'password'}
                        className="border p-2 w-full outline-blue-500"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                    <div className="mt-1 text-end">
                        <input
                            type="checkbox"
                            id="showNewPassword"
                            checked={showNewPassword}
                            onChange={() => setShowNewPassword(!showNewPassword)}
                            className="mr-2"
                        />
                        <label htmlFor="showNewPassword">Show Password</label>
                    </div>
                </div>

                {/* Confirm Password */}
                <div className="mb-4">
                    <input
                        type={showConfirmPassword ? 'text' : 'password'}
                        className="border p-2 w-full outline-blue-500"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        disabled={loading}
                    />
                    <div className="mt-1 text-end">
                        <input
                            type="checkbox"
                            id="showConfirmPassword"
                            checked={showConfirmPassword}
                            onChange={() => setShowConfirmPassword(!showConfirmPassword)}
                            className="mr-2"
                        />
                        <label htmlFor="showConfirmPassword">Show Password</label>
                    </div>
                </div>

                <button
                    type="submit"
                    className={`bg-blue-500 text-white p-2 rounded w-full ${loading ? 'opacity-50' : ''}`}
                    disabled={loading}
                >
                    {loading ? 'Resetting...' : 'Reset Password'}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
